module.exports = __webpack_public_path__ + "static/media/Establishing-Businesses.36823ac0.jpg";